import { Box, Typography } from '@mui/material';
import Global from '../../../../Services/Common/Global';
import React from 'react';

export const SignSection = ({ title, approvers }) => {
  if (!approvers || approvers.length === 0) return null;

  return (
    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #E5E7EB' }}>
      <Typography
        sx={{ fontWeight: 700, fontSize: '16px', color: '#111827', mb: 1.5 }}
      >
        {title}
      </Typography>
      {approvers.map((approver, index) => (
        <Box
          key={approver.approverId || index}
          sx={{
            px: 2.5,
            py: 1.5,
            borderRadius: '12px',
            backgroundColor: '#F9FAFB',
            border: '1px solid #E5E7EB',
            mb: index < approvers.length - 1 ? 1.5 : 0,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{ fontWeight: 600, fontSize: '14px', color: '#6B7280' }}
            >
              확인자
            </Typography>
            <Typography
              sx={{ color: '#EA580C', fontWeight: 700, fontSize: '16px' }}
            >
              {approver.approverName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 1,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: '14px', color: '#374151', mb: 0.5 }}>
                {approver.approverDepNm}
              </Typography>
              <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>
                {approver.approverPosition?.split(',').map((pos, idx) => (
                  <React.Fragment key={idx}>
                    {idx > 0 && <br />}
                    {pos.trim()}
                  </React.Fragment>
                ))}
              </Typography>
            </Box>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '100px',
                height: '40px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  color: '#9CA3AF',
                  position: 'absolute',
                }}
              >
                (인)
              </Typography>
              {approver.signaturePath && (
                <Box
                  component="img"
                  src={`${Global.file.useUrl}files/${approver.signaturePath}`}
                  sx={{
                    width: '80px',
                    position: 'absolute',
                    zIndex: 2,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
